import angular from "angular";

angular
	.module('app')
	.component('packetCreateModal', {
		template: require('./packet-create-modal.html'),
        controller: ['$http', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });
            
function controller($http, Notifier) {
        
	let $ctrl = this;

	$ctrl.selectedCount = 0;

	$ctrl.$onInit = () => {
        $ctrl.courses = $ctrl.resolve.courses;

        $ctrl.courses.forEach(course => {
            course.isSelected = false;
        });
    }

	$ctrl.courseSelected = () => {
        $ctrl.selectedCount = $ctrl.courses.filter(v => v.isSelected).length;
    };

	$ctrl.save = () => {
	    $ctrl.loading = false;

        $http
            .post('/admin/packets', {
                courses_ids: $ctrl.courses.filter(v => v.isSelected).map(v => v.id)
            })
            .then(res => {
                Notifier.success('Успешно добавлен');
                $ctrl.close();
            })
            .catch(err => {
                Notifier.error(err.data.message);
            })
            .finally(() => {
                $ctrl.loading = false;
            });
    };

}